export default __webpack_public_path__ + "static/media/nip_3.b934a3c5.jpg";